const employerFlowStyles = {
    h2: {
        fontSize: "2rem",
        fontWeight: "600",
        color: "#465578",
        marginBottom: "0px"
    }
}
export default employerFlowStyles;